import "./default-button.component.scss";
// import { IButtonProps, DefaultButton } from '@fluentui/react/lib/Button';

// export const DefaultButton: React.FunctionComponent<IButtonProps> = (props) => {
import Button from "@mui/material/Button";
import { ButtonProps } from "@mui/material";
export const DefaultButton: React.FunctionComponent<ButtonProps> = (props) => {
  return (
    <>
      <Button
        variant={props.variant ?? "text"}
        {...props}
        sx={{ textTransform: "none!important" }}
      >
        {props.children}
      </Button>
      {/* <DefaultButton className='default-btn' {...props} /> */}
    </>
  );
};
